module.exports = __webpack_public_path__ + "img/DE00616.16c0a0b6.png";